import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { RouteComponentProps, withRouter } from "react-router"
import { JSONRPCErrorCatch } from "../../../../error/error"
import Width from "../../../../style/enum/width"
import { Headline } from "../../../../components/parts/headline/headline"
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog"
import styled from "styled-components"
import { Wrapper } from "../../../../components/templates/wrapper"
import { ChannelIcon } from "../../../../components/parts/channel-icon"
import { Form } from "./form/form"
import {
  ChangeIconButton,
  IImageData,
} from "../../../../components/parts/buttons/change-icon-button"
import DefaultChannelIcon from "./assets/images/default_channel_icon.png"
import { JSONRPCClientBuilder } from "../../../../request/JSONRPCClientBuilder"
import {
  ChannelRPC,
  CreateChannelInput,
} from "../../../../rpcs/dist/ChannelRPC"
import { IFormField } from "./form/form-meta"

interface IProps
  extends RouteComponentProps<{
    name: string
  }> {}

interface IState {
  profileImage: IImageData | null
}

export class Component extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.submit = this.submit.bind(this)
    this.uploadImage = this.uploadImage.bind(this)
    this.state = {
      profileImage: null,
    }
  }

  public render() {
    return (
      <StyledWrapper maxWidth={Width.EPISODE}>
        <Headline>
          <FontAwesomeIcon icon={faCog} /> チャンネル新規作成
        </Headline>
        <IconWrapper>
          {this.state.profileImage && (
            <ChannelIcon
              size={128}
              title={"チャンネルアイコン"}
              url={`data:${this.state.profileImage!.contentType};base64,${
                this.state.profileImage!.base64EncodedData
              }`}
            />
          )}
          {!this.state.profileImage && (
            <ChannelIcon
              size={128}
              title={"チャンネルアイコン"}
              url={DefaultChannelIcon}
            />
          )}
          <ChangeIconButton receiveImageData={this.uploadImage} />
        </IconWrapper>
        <Form onSubmit={this.submit} />
      </StyledWrapper>
    )
  }

  private async submit(values: IFormField) {
    const inputData: CreateChannelInput = {
      name: values.name,
      screenName: values.screenName,
      description: values.description,
    }
    if (this.state.profileImage) {
      inputData.image = this.state.profileImage
    }
    const res = await JSONRPCClientBuilder.build(ChannelRPC)
      .createChannel(inputData)
      .catch(JSONRPCErrorCatch)
    if (res !== -1) {
      this.props.history.push(`/channel/${res.name}`)
    }
  }

  private uploadImage(images: IImageData) {
    this.setState({
      profileImage: images,
    })
  }
}

export default withRouter(Component)

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 24px 0 24px;
`

const StyledWrapper = styled(Wrapper)`
  margin-bottom: 32px;
`
